/** Coloca-nest `/internal/payments/incidents` (staff only). Base URL already includes `/api/v1`. */
export const PAYMENT_INCIDENTS_ENDPOINTS = {
  LIST: "/internal/payments/incidents",
  SUMMARY: "/internal/payments/incidents/summary",
  byId: (id: string) => `/internal/payments/incidents/${id}`,
  report: (id: string) => `/internal/payments/incidents/${id}/report`,
  events: (id: string) => `/internal/payments/incidents/${id}/events`,
  clientRefund: (id: string) => `/internal/payments/incidents/${id}/client-refund`,
} as const;

/** The backend takes at most this many files per timeline entry (`MAX_INCIDENT_ATTACHMENTS`). */
export const MAX_INCIDENT_ATTACHMENTS = 5;

/** An open incident with nothing new for this long needs a follow-up (the backend's `stale`). */
export const INCIDENT_STALE_AFTER_DAYS = 7;

export const INCIDENT_DESCRIPTION_MAX = 2000;
export const INCIDENT_NOTE_MAX = 4000;
export const INCIDENT_CASE_REFERENCE_MAX = 64;
export const INCIDENT_REFUND_NOTE_MAX = 500;
